import React from "react";
import { Link } from "react-router-dom";
import "./About.css";

const About = () => {
  return (
    <section className="ib-section">
      <div className="ib-wrapper">

        {/* Left Image */}
        <div className="ib-image">
          <img src={`${process.env.PUBLIC_URL}/assets/images/About.jpeg`} alt="About INTEL BUILD" />

        </div>

        {/* Right Content */}
        <div className="ib-content">
          <h2>About INTELBUILD</h2>
          <h3>Engineering Intelligence. Building the Future.</h3>
          <p>
            At INTELBUILD Engineering Services LLP, we believe that every successful project begins 
            with intelligent engineering.We are a multidisciplinary Architecture, Structural Engineering,
            BIM, and Project Management consultancy delivering innovative, practical,
            and sustainable solutions for the built environment.
          </p>

          <div className="ib-buttons">
            <Link to="/about" className="read-btn">READ MORE</Link>
            
          </div>
        </div>

      </div>
    </section>
  );
};

export default About;
